import { Eye, EyeOff, TriangleAlert, X } from "lucide-react";
import { format, parseISO } from "date-fns";
import { useTranslation } from "react-i18next";
import { useDateLocale } from "../../i18n/use-date-locale";
import { cn } from "../../lib/utils";
import type { ReferenceSchedule } from "../../stores/reference-schedule-store";
import { useReferenceScheduleStore } from "../../stores/reference-schedule-store";

const iconButton = "flex size-5 items-center justify-center rounded-full text-neutral-500 hover:bg-neutral-100 hover:text-neutral-900";

export function ReferenceScheduleRow({ reference, monday }: { reference: ReferenceSchedule; monday: string }) {
  const { t } = useTranslation();
  const locale = useDateLocale();
  const { rename, toggle, remove } = useReferenceScheduleStore();
  const sourceMonday = reference.document.selectedDate;
  const shifted = sourceMonday !== monday; // Aligned by weekday onto my week
  const sourceWeek = format(parseISO(sourceMonday), "M/d", { locale });
  const VisibleIcon = reference.visible ? Eye : EyeOff;
  const toggleLabel = reference.visible ? t("reference.hide") : t("reference.show");
  return (
    <li className={cn("flex h-7 items-center gap-1 rounded-full border bg-white pl-2 pr-1", !reference.visible && "opacity-50")}
      style={{ borderColor: reference.color }}>
      <span aria-hidden="true" className="size-2 shrink-0 rounded-full" style={{ backgroundColor: reference.color }} />
      <input value={reference.name} aria-label={t("reference.name")} title={t("reference.name")} onChange={(event) => rename(reference.id, event.target.value)}
        className="field-sizing-content min-w-8 max-w-48 rounded bg-transparent px-1 text-xs hover:bg-neutral-100 focus-visible:bg-neutral-100 focus-visible:outline-none" />
      {shifted && (
        <span title={t("reference.shifted", { week: sourceWeek })} className="flex items-center gap-0.5 text-[10px] text-amber-700">
          <TriangleAlert aria-hidden="true" className="size-3 shrink-0" />
          {t("reference.shiftedShort", { week: sourceWeek })}
        </span>
      )}
      <button type="button" aria-label={toggleLabel} title={toggleLabel} className={iconButton} onClick={() => toggle(reference.id)}><VisibleIcon className="size-3" /></button>
      <button type="button" aria-label={t("reference.remove")} title={t("reference.remove")} className={iconButton} onClick={() => remove(reference.id)}><X className="size-3" /></button>
    </li>
  );
}
